function FeedbackMessage({ tone = 'info', message, action = null, className = '' }) {
  if (!message) {
    return null;
  }

  const toneClassName =
    tone === 'error'
      ? 'border-[#efd2cd] bg-[#fbefed] text-[#9b4e43]'
      : tone === 'success'
        ? 'border-[#d9ead8] bg-[#f2f8f0] text-[#4f7650]'
        : tone === 'warning'
          ? 'border-[#f59e0b] bg-[#fffbeb] text-[#92400e] shadow-[0_12px_28px_rgba(245,158,11,0.2)]'
          : 'border-[#e7ddd4] bg-[#faf7f2] text-[#73675d]';

  return (
    <div
      className={`flex flex-col gap-3 rounded-[18px] border px-4 py-3 text-[0.95rem] shadow-[0_8px_18px_rgba(var(--theme-shadow-rgb),0.025)] sm:flex-row sm:items-center sm:justify-between ${toneClassName} ${className}`}
      role={tone === 'error' || tone === 'warning' ? 'alert' : 'status'}
    >
      <span className="whitespace-pre-line">{message}</span>
      {action ? (
        <button
          className="inline-flex min-h-[34px] shrink-0 items-center justify-center rounded-full bg-[var(--theme-accent)] px-4 text-[0.84rem] font-semibold text-white transition hover:bg-[var(--theme-accent-strong)]"
          type="button"
          onClick={action.onClick}
        >
          {action.label}
        </button>
      ) : null}
    </div>
  );
}

export default FeedbackMessage;
